import React from 'react';
import { useSelector } from 'react-redux';
import {
	CButton,
	CModal,
	CModalBody,
	CModalFooter,
	CModalHeader,
	CModalTitle,
	CFormInput,
	CListGroup,
	CListGroupItem,
	CSpinner,
} from '@coreui/react';
import PropTypes from 'prop-types';
import { UFunc } from "../helpers/functions";

const pjson 		= require('../../package.json')
const MyDialoglookupconsent = props => {
	const {
		show,toggle,dialogHeader,inputValue,urlTarget,onKlikPilihItem,
		prosesExpired,showToast,setSessionaktif,
		...rest
	} = props;

	const uDataconsentObj				= useSelector(state => state.gConsentcreateObj) || {};
	const uBahasaObj  					= useSelector(state => state.listBahasa);
	const uTokenObj						= JSON.parse(localStorage.getItem("token")||"{}");

	const uDokterID 					= parseInt(uDataconsentObj.id_dokter)||0;
	const uJenisconsentID				= parseInt(uDataconsentObj.jenis_id)||0;

	const [uISDataloading,setDataloading]	= React.useState(false);
	const [uInputValue,setInputValue]	= React.useState(inputValue || "xx");
	const [uCursorPos,setCursorPos]		= React.useState(-1);
	const [uDatalookupArr,setDatalookupArr]	= React.useState([]);
	const [uDataviewArr,setDataviewArr]	= React.useState([]);

	const hdlKeyDownModal=(_EV)=>{
		if (_EV.keyCode === 38 && uCursorPos >= 0) {//--->UP
			_EV.preventDefault();
			setCursorPos(uCursorPos-1);
			return;
		} else if (_EV.keyCode === 40 && uCursorPos < uDataviewArr.length-1) {//--->DOWN
			_EV.preventDefault();
			setCursorPos(uCursorPos+1);
			return;
		}

		if(_EV.keyCode === 13) {
			if(uCursorPos < 0 || uCursorPos >= uDataviewArr.length) return;

			_EV.preventDefault();
			const vIdx = uCursorPos;
			hdlKlikpilihitem(uDataviewArr[vIdx].id);
			return;
		}
	}
	const hdlKeyDownInput=(_EV)=>{
		if(_EV.keyCode===13) {
			_EV.preventDefault();
			setCursorPos(0);
			return;
		}
	}
	const hdlKlikpilihitem = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM);

		const vArridx	= UFunc.getObjectIndeks(uDatalookupArr,_IDITEM);

		toggle();
		onKlikPilihItem(uDatalookupArr[vArridx]||{});
	}

	const apiLoaddata = () => {
		const vElsimpan	= document.getElementById("btnDialogViewOK");
		vElsimpan && (vElsimpan.disabled = true);
		setDataloading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElsimpan && (vElsimpan.disabled = false);
			setDataloading(false);
			showToast(uBahasaObj.pesan_periksasukses||"Berhasil","SUKSES");
			//uNavigate(uUrlbefore,{replace:true});
		},2500);return;//-*/
		const vDATAS	= JSON.stringify({
			send_jenisid: uJenisconsentID,
			send_dokterid: uDokterID,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= urlTarget;

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			vElsimpan && (vElsimpan.disabled = false);
			setDataloading(false);
			if(output_string.tampil) {
				const vTmpArr	= JSON.parse(output_string.dataarr_str || "[]");
				setDatalookupArr(vTmpArr);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialoglookupconsent - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setDataloading(true); prosesExpired(); return;
			}
		})
		.catch((error) =>{
			vElsimpan && (vElsimpan.disabled = false);
			setDataloading(false);

			console.log("(MyDialoglookupconsent - apiLoaddata) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR")
		});
	}

	React.useEffect(()=>{
		return ()=>{ toggle() }
	},[])//-*/
	React.useEffect(()=>{
		if(!show) { 
			//console.log("[show] LOAD 2 = "+show);
			setInputValue(""); setCursorPos(-1);
			setDatalookupArr([]);
			return;
		}

		apiLoaddata();

		//console.log("[show] LOAD 1 = "+show);
		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);

			const vElsinput	= document.getElementById("inpdialoglookup");
			const vElsrow	= document.getElementById("idrowscroll");

			//console.log("[show] Checked..");
			vElsinput && vElsinput.scrollTo(0,0);
			if(inputValue === "") 
				vElsinput && vElsinput.focus();
			else
				vElsinput && vElsinput.select();
		},350);//-*/
	},[show]);
    React.useEffect(() => {
		setDataviewArr(uDatalookupArr.slice(0,100));
	},[uDatalookupArr]);
    React.useEffect(() => {
		const vElsinput	= document.getElementById("inpdialoglookup");
		const vElsrow	= document.getElementById("idrowscroll");

		if(uCursorPos <= 0) {
			vElsinput && vElsinput.scrollTo(0,0);
		}

		if(uCursorPos < 0) {
			vElsinput && vElsinput.focus();
			return;
		}

		if(document.getElementById("idlistitem"+uCursorPos))
			document.getElementById("idlistitem"+uCursorPos).focus();
    }, [uCursorPos]);
	React.useEffect(()=>{
		setCursorPos(-1);
		if(uInputValue==="") {
			const vDataViewArr	= uDatalookupArr.slice(0,100);
			setDataviewArr(vDataViewArr);
			return;
		}

		let vSearchArr = uDatalookupArr.filter((vItem)=>
			(vItem.caption||"UNDF").toUpperCase().includes((uInputValue||"UNDF").toUpperCase()));
		if(uInputValue.length < 3)
			vSearchArr	= vSearchArr.slice(0,100);
		setDataviewArr(vSearchArr);//-*/
	},[uInputValue]);

	//console.log("("+cComponentname+") Checked..");

	return (
		<div onKeyDown={(e)=>hdlKeyDownModal(e)}>
		<CModal alignment="center"
			className="z-2099"
			visible={show} 
			scrollable
			onClose={toggle}>
		<CModalHeader closeButton className="bg-dark text-light">
			<CModalTitle>{dialogHeader || MyDialoglookupconsent.defaultProps.dialogHeader}</CModalTitle>
		</CModalHeader>

		<CModalBody className="p-0" id="idmodalbody">
			<div className="sticky-top bg-light mx-auto p-3 px-5" id="idheaderlookup">
				<CFormInput size="sm"
					autoFocus={true}
					value={uInputValue}
					onChange={(e)=>setInputValue(e.target.value)}
					onKeyDown={(e)=>hdlKeyDownInput(e)}
					onFocus={(e)=>setCursorPos(-1)}
					id="inpdialoglookup"/>
			</div>

			<div className="p-3" id="idrowscroll" style={{minHeight:window.innerHeight-250}}>
			{(uISDataloading) ? (
				<div className="text-center py-5">
				<CSpinner color="primary"/>
				</div>
			) : (
				<CListGroup> 
					<CListGroupItem 
						id="idlistitem_"
						onClick={()=>hdlKlikpilihitem(0)}
						className="py-2 list-group-item-action classcursorpointer">
						<b>*) LAINNYA: </b><i className="text-muted">[ISI SENDIRI]</i>
					</CListGroupItem>

					{(uDataviewArr).map((vItems,vKeys)=>{
						return (
							<React.Fragment key={vKeys}>
							{(vKeys <= 0) && (
								<div className="classborderbottom bg-dark pt-1"/>
							)}

							<CListGroupItem
								id={"idlistitem"+vKeys}
								tabIndex={vKeys}
								active={uCursorPos === vKeys}
								onClick={()=>hdlKlikpilihitem(vItems.id)}
								className="py-2 list-group-item-action classcursorpointer">
								<div className="d-flex justify-content-between">
								<div className="pe-1">{vItems.caption}</div>
								{vItems.harga_satuan && (
								<div className="ps-1 text-end fw-bolder">
									Rp{UFunc.formatAngka(vItems.harga_satuan)}
								</div>
								)}
								</div>
							</CListGroupItem>
							</React.Fragment>
						)
					})}
				</CListGroup>
			)}
			</div>
		</CModalBody>

		<CModalFooter>
			<CButton size="sm" color="dark" 
				className="px-3"
				onClick={toggle}
				id="btnDialogViewOK"> 
			{uBahasaObj.word_ok||"Ok !"}
			</CButton>
		</CModalFooter>
		</CModal>
		</div>
	)//>
}
MyDialoglookupconsent.defaultProps = {
	show: false,
	urlTarget: "",
	dialogHeader: "Lookup Data Item",
	onKlikPilihItem:()=>{},
};

MyDialoglookupconsent.propTypes = {
	show: PropTypes.bool,            
	urlTarget: PropTypes.string, 
	toggle: PropTypes.func,     
	dialogHeader: PropTypes.string,
	inputValue: PropTypes.string,
	onKlikPilihItem: PropTypes.func,     
}

export default MyDialoglookupconsent;
